<!-- 查询可用的商家券接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {"traderCode":"789","sellBillId":20160723162730110},
            responseCode: {
                "data": {
                    "couponSn":"SDF235R23D",
                    "name":"1小时优惠",
                    "balanceType":"0",
                    "couponType":"0",
                    "faceValue":"0",
                    "faceValueShow":"0",
                    "originalPrice":"0",
                    "useRule":"0",
                    "isCover":"0",
                    "maxCoverNum":"0",
                    "validFrom":"20170910000000",
                    "validTo":"20170911000000",
                    "validTimeLength":"10",
                    "qrCode":"wwww.yiidanting.com",
                    "leftCount":"10"
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台查询可用的电子券",
                t_url: this.commonUrls.test+"queryUsableCoupon",
                p_url: this.commonUrls.prod+"queryUsableCoupon",
                precondition: "无",
                fitSystem: "VEMS传统停车场，云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'traderCode', info2: '是', info3: 'String', info4: '授权商对应的商家代号' },
                        { info1: 'sellBillId', info2: '是', info3: 'Long', info4: '销售账单ID' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'couponSn', info2: '是', info3: 'String', info4: '发放券的唯一编号' },
                        { info1: 'name', info2: '是', info3: 'String', info4: '优惠券名称' },
                        { info1: 'balanceType', info2: '是', info3: 'int', info4: '结算类型' },
                        { info1: 'couponType', info2: '是', info3: 'int', info4: '优惠类型，0：免费券，车费0元结算；1：金额扣减券，车费减免固定金额结算；2：金额折扣券，车费折扣减免结算；3：金额固定值券，车费按券的固定值结算；4：时间券，时间减免后再按车费结算；5:不同计价券,按不同计价规则车费结算' },
                        { info1: 'faceValue', info2: '是', info3: 'String', info4: '面值，免费券:默认0；金额扣减券:为大于0的正数且保留2位小数；金额折扣券:为0-1且保留2位小数；金额固定券:为大于0的正数且保留2位小数；时间券:为大于0的整数；说明:金额相关的券都以元为单位，时间券以分为单位' },
                        { info1: 'faceValueShow', info2: '是', info3: 'String', info4: '面值展示' },
                        { info1: 'originalPrice', info2: '是', info3: 'Decimal', info4: '原价' },
                        { info1: 'realPrice', info2: '是', info3: 'Decimal', info4: '实价' },
                        { info1: 'useRule', info2: '是', info3: 'String', info4: '使用规则表达式' },
                        { info1: 'isCover', info2: '是', info3: 'int', info4: '是否可以覆盖使用（暂无使用）' },
                        { info1: 'maxCoverNum', info2: '是', info3: 'int', info4: '最大覆盖张数（暂无使用）' },
                        { info1: 'validFrom', info2: '是', info3: 'String', info4: '最早有效开始时间，yyyyMMddHHmmss' },
                        { info1: 'validTo', info2: '是', info3: 'String', info4: '最晚有效结束时间，yyyyMMddHHmmss' },
                        { info1: 'validTimeLength', info2: '是', info3: 'int', info4: '有效时长(分钟)' },
                        { info1: 'qrCode', info2: '是', info3: 'String', info4: '二维码内容' },
                        { info1: 'leftCount', info2: '是', info3: 'int', info4: '剩余张数（包含本张）' }
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/preferential/coupon/queryUsableCoupon.vue